export const CART_UPDATED_EVENT = 'ciCartUpdated';
export const USER_AUTHENTICATED_EVENT = 'USER_AUTHENTICATED';
